import "./ConsentForm.scss";
import { deepClone, getFormattedDateUSFormat } from "src/legacy/utils/helpers";
import { useEffect, useState } from "react";

interface Props {
    data: any;
    onDataInput: (updatedData: any) => void;
    answersObject: any;
    currentPage: number;
}

export const ConsentDate = ({
    data,
    onDataInput,
    answersObject,
    currentPage,
}: Props) => {
    const [dateValue, setDateValue] = useState<string>("");

    useEffect(() => {
        if (answersObject) {
            const _answersObject = deepClone(answersObject);
            const _datevalue = getFormattedDateUSFormat(new Date());

            setDateValue(_datevalue);

            if (_answersObject && data?.unique_key && _datevalue) {
                _answersObject[currentPage][data.unique_key] = {
                    error: undefined,
                    answersData: [_datevalue],
                };

                if (onDataInput) {
                    onDataInput(_answersObject);
                }
            }
        }
    }, []);

    return (
        <div style={{ margin: "2rem" }}>
            <div
                id={`consent-${data.unique_key}`}
                style={{ marginTop: "1rem" }}
            >
                <label style={{ fontWeight: "bold" }}>
                    {data?.display_label}
                </label>
                <label style={{ marginLeft: "8px" }}>{dateValue}</label>
            </div>
        </div>
    );
};
